/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCountriesDetails } from "../../Services/redux/Country-details/CountryDetailsActions";
import { fetchVehiclesDetails } from "../../Services/redux/Vehicles-details/VehiclesDetailsActions";
import { fetchCpuDetails } from "../../Services/redux/CPU-details/CpuDetailsActions";
import "./ApplicationDetailsTargetting.css";
import ApplicationDetailsCountries from "../ApplicationDetails-Countries/ApplicationDetailsCountries";
import ApplicationDetailsVehicles from "../ApplicationDetails-Vehicles/ApplicationDetailsVehicles";
import ApplicationDetailsCPU from "../ApplicationDetails-CPU/ApplicationDetailsCPU";
import { Grid2, Container, Typography } from "@mui/material";
import { getConfig } from "../../config";
import PropTypes from "prop-types";

function ApplicationDetailsTargetting({ postCallTheNewSubmission }) {
  const dispatch = useDispatch();
  const submissionData = useSelector(
    (state) => state.submissionDetails.submissionDetails
  );
  const countries = useSelector((state) => state.countryDetails.countries);
  const vehicles = useSelector((state) => state.vehiclesDetails.vehicles);
  const architectures = useSelector((state) => state.cpuDetails.architechures);
  const checkedDefaultAll = false;
  useEffect(() => {
    dispatch(fetchCountriesDetails());
    dispatch(fetchVehiclesDetails());
    dispatch(fetchCpuDetails());
  }, []);

  return (
    <Container maxWidth="lg">
      <Grid2 container justifyContent="flex-start" alignItems="center">
        <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
          <section
            id="targeting"
            className="targetting"
            style={
              submissionData &&
              Object.keys(submissionData).length > 0 &&
              submissionData.status !== "DRAFT"
                ? { borderBottom: "1px solid rgba(18, 20, 21, 0.2) !important" }
                : { width: "85%", marginTop: "30px" }
            }
          >
            <Typography
              sx={{
                "font-weight": "bold !important",
                "font-size": "20px !important",
                color: "rgba(18, 20, 21, 1) !important",
                "margin-right": "auto !important",
              }}
              className="uploadSignedApkText"
            >
              Targeting
            </Typography>
            <div className="targetting-wrapper" style={{ marginTop: "15px" }}>
              {countries && countries.length > 0 && (
                <ApplicationDetailsCountries
                  countries={countries}
                  submissionData={submissionData}
                  postCallTheNewSubmission={postCallTheNewSubmission}
                  checkedDefaultAll={checkedDefaultAll}
                />
              )}
              {vehicles &&
                vehicles.length > 0 &&
                getConfig().REACT_APP_PORTAL ===
                  "seller" && (
                    <ApplicationDetailsVehicles
                      vehicles={vehicles}
                      submissionData={submissionData}
                      postCallTheNewSubmission={postCallTheNewSubmission}
                    />
                  )}
              {!sessionStorage.getItem("isOemSeller") &&
                sessionStorage.getItem("idpLogin") !== "true" &&
                architectures &&
                architectures.length > 0 &&
                getConfig().REACT_APP_PORTAL === "seller" && (
                  <ApplicationDetailsCPU
                    architectures={architectures}
                    submissionData={submissionData}
                    postCallTheNewSubmission={postCallTheNewSubmission}
                  />
                )}
              {architectures &&
                architectures.length > 0 &&
                getConfig().REACT_APP_PORTAL === "domain-approver" && (
                  <ApplicationDetailsCPU
                    architectures={architectures}
                    submissionData={submissionData}
                    postCallTheNewSubmission={postCallTheNewSubmission}
                  />
                )}
            </div>
          </section>
        </Grid2>
      </Grid2>
    </Container>
  );
}

ApplicationDetailsTargetting.propTypes = {
  postCallTheNewSubmission: PropTypes.func.isRequired,
};

export default ApplicationDetailsTargetting;
